import { render, staticRenderFns } from "./foto.vue?vue&type=template&id=105dc1e0&"
import script from "./foto.vue?vue&type=script&lang=js&"
export * from "./foto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports